export default {
	data: () => ({
		lsWorkflow: null,
	}),
	methods: {
		async restoreFromLocalStorage(ls) {
			if (this.doesLsPathMatchCurrentPath(ls.path)) {
				const {workflow_steps} = ls;
				await this.$store.dispatch('restoreWorkflow/restoreWfs', workflow_steps);

                await this.$store.commit('tags/setTagsToBeRestored', {
                    step:ls.activeStepTags,
                    workflow:ls.activeWorkflowTags,
                    publicationId: ls.tagsPublicationId,
                });
				// trigger snackbar if content as changed from country availability
				if (this.$store.getters['restoreWorkflow/countryAvailabilityChanged']) {
					this.$root.$emit('countryAvailabilityChanged');
					this.$store.dispatch('restoreWorkflow/setCountryAvailabilityChanged', false);
				}

				this.$store.commit('setWorkflowHeadline', ls.workflow_title);

				if (this.checkIfLoggedIn() && !this.isJwtExpired()) {
					this.showRequestsModal = ls.requestQuote || ls.requestGenomic;
					this.optionsModalKey = ls.optionsModalKey;
				}
			}

			this.clearLocalStorage();
		},
		stepFromMyworkflowHasCustomProduct(products) {
			return products.find((product) => product.customProduct);
		},
		doesLsPathMatchCurrentPath(path) {
			// check if they are coming back to the same page
			return window.location.pathname === path;
		},
		buildLsObjForWorkflowRestore() {

			const activeStepTags = {...this.$store.getters['tags/activeStepTags']};
			const activeWorkflowTags = {...this.$store.getters['tags/activeTags']};
			const tagsPublicationId = this.$store.state.tags.tagsPublicationId;

			let activeStepTagsObj = Object.keys(activeStepTags).reduce((acc, stepKey) => {
				acc[stepKey] = Object.keys(activeStepTags[stepKey]).reduce((acc_g, group) => {
					acc_g[group] = [...activeStepTags[stepKey][group]];
					return acc_g;
				}, {});
				return acc;
			}, {});
			let activeworkflowTagsObj = Object.keys(activeWorkflowTags).reduce((acc, group) => {
				acc[group] = [...activeWorkflowTags[group]];
				return acc;
			}, {});

			// builds obj structure for a quick restore of workflow
			const wflObj = {
				workflow_title: this.$store.state.workflowHeadline || this.$store.state.workflowDefaultHeadline,
				workflow: this.$store.getters['workflow/wfSteps'],
				workflow_steps: [],
				path: window.location.pathname,
				requestQuote: this.requestQuoteSelected,
				requestGenomic: this.requestGenomicSelected,
				optionsModalKey: this.optionsModalKey,
				activeStepTags: activeStepTagsObj,
				activeWorkflowTags: activeworkflowTagsObj,
				tagsPublicationId
			};

			// get values for each step
			wflObj.workflow_steps = this.$store.getters['workflow/wfSteps'].map((wfs) => {
				const obj = {
					name: wfs.name,
					stepEnabled: wfs.stepEnabled,
					selectedProduct: wfs.selected,
					labNotes: wfs.labNotes,
				};

				// Add custom step content
				if (wfs.customContent) obj.customContent = wfs.customContent;

				// add products
				obj.products = wfs.products
					? wfs.products.map((product) => {
							if (product && product.customContent)
								return {key: product.key, customContent: product.customContent};
							return product.pimId;
					  })
					: null;

				// add filters
				if (wfs.filterCategories) {
					const keys = Object.keys(wfs.filterCategories);
					obj.filters = keys.map((key) => ({
						name: key,
						selectedFilters: wfs.filterCategories[key].filterGroup.selectedFilters.updated,
					}));
				}
				return obj;
			});
			return wflObj;
		},
		saveChangeToLocalStorage() {
			if (!this.$store.state.supportsLocalStorage) return;
			const lsObjForWorkflowRestore = this.buildLsObjForWorkflowRestore();
			localStorage.setItem('lsWorkflow', JSON.stringify(lsObjForWorkflowRestore));
		},
		clearLocalStorage() {
			localStorage.removeItem('lsWorkflow');
		},
		saveMyWorkflowsToLocalStorage(workflows) {
			localStorage.setItem('lsMyWorkflows', JSON.stringify({workflows}));
		},
		saveMyWorkflowIdToLocalStorage(id) {
			localStorage.setItem('myWfId', JSON.stringify(id));
		},
		getPropertyFromLocalStorage(key) {
			return JSON.parse(localStorage.getItem(key));
		},
		async restoreFromLsMyWorkflows(workflowId) {
			const lsMyWorkflow = this.getMyWorkflowFromLocalStorage();
			await this.setWorkflowDataToStore(lsMyWorkflow);
		},
		updateTitleInLsMyWorkflows(workflowId, workflowTitle) {
			const lsMyWorkflows = JSON.parse(localStorage.getItem('lsMyWorkflows'));
			const workflow = lsMyWorkflows.workflows.find((lswf) => lswf.id == workflowId);
			workflow.title = workflowTitle;
			this.saveMyWorkflowsToLocalStorage(lsMyWorkflows.workflows);
		},
	},
};
